import React from "react";
import Wrp from "../../../hoc/Wrp/Wrp";
import {getSelectedValueFromForm, getSelectedValueBasedOnField, isSet } from "../../../Utils/CommonFunctions";
import { extractFieldValue,flattenPathObject, extractStylesAsObjects } from "../MarkupFunctions";
import { getUserInfo } from "../../../Utils/UserFunctions";



  const ScmDecisionMaking = ({attributes,elmtParams})=>{
     const {convertAndRenderElement} = elmtParams;
    // const {children,dynamicAssignVar,defProps} = elmtParams; //loopData,dataTable,
    let tagName = Wrp;
    let decisionResult    = [];
    const decisionObj     = getDecisionMaking(attributes,elmtParams);
    // console.log('decisionObj',decisionObj);
    let updateAttributes  = attributes;
    if(isSet(decisionObj['elseif'],{result:false}).result===true){
      updateAttributes    = isSet(decisionObj['elseif'],{attributes:{}}).attributes;
      decisionResult      = isSet(decisionObj['elseif'],{children:[]}).children;
    }else{
      updateAttributes    = isSet(decisionObj['else'],{attributes:{}}).attributes;
      decisionResult      = isSet(decisionObj['else'],{children:[]}).children;
    }
    if(decisionResult.length===0){
      return false;
    }else{
      return React.createElement(tagName, {...updateAttributes}, convertAndRenderElement(decisionResult,elmtParams));
    }
}
export default ScmDecisionMaking;

const getDecisionMaking = (attributes,elmtParams)=>{
  const {children,defProps} = elmtParams;
  const {rateWithShipments,outputResponse} = defProps;
  let dynamicVar = elmtParams.dynamicVar;
  let loggedInData = {};
  try {
    const loggedIn = getUserInfo();
    loggedInData = loggedIn && loggedIn.data ? loggedIn.data : {};
  } catch (e) {
    loggedInData = {};
  }
  dynamicVar = {
    ...outputResponse,
    ...dynamicVar,
    user: {
      id: isSet(loggedInData.id, ""),
      email: isSet(loggedInData.email, ""),
      role_name: isSet(loggedInData.role_name, ""),
      profile_name: isSet(loggedInData.profile_name, ""),
      is_external: loggedInData.is_external === true ? "true" : "false",
    },
  }
  let {entries,flatmap} = attributes;
  if(isSet(entries,null)!==null){
    const entriesValue = rateWithShipments && rateWithShipments[entries] !== undefined
      ? rateWithShipments[entries]
      : isSet(dynamicVar[entries], null);
    dynamicVar = {
      ...dynamicVar,
      [entries]: entriesValue
    }
    if(isSet(flatmap,null)!==null){
      dynamicVar = {
        ...dynamicVar,
        [attributes.var]:flattenPathObject(dynamicVar[entries],flatmap)
      }
    }
  }

  let returnDecision = decisionMakingCondition(attributes,{...elmtParams,dynamicVar:dynamicVar},{});
  if(isSet(returnDecision['elseif'],{result:false}).result===true){
    return returnDecision;
  }
  
  children.map((item,itemIndex)=>{
      const attribs = (item.hasOwnProperty('attribs')===true)?item.attribs:{};
      let childAttributes ={
        ...attribs,
        id:isSet(attribs.id,itemIndex)
      }
      let tagName = (item.hasOwnProperty('name')===true)?item.name:'';
      if(childAttributes.hasOwnProperty('style') && typeof childAttributes.style==='string'){
        childAttributes.style = extractStylesAsObjects(childAttributes.style);
      }
      returnDecision = decisionMakingCondition(childAttributes,{...elmtParams,dynamicVar:dynamicVar,children:item.children,tagName:tagName},returnDecision);
    })
    return returnDecision;
}

  
const decisionMakingCondition = (attributes,elmtParams,returnDecision)=>{
  const {tagName,defProps,children,dynamicVar} = elmtParams;
  const {fieldGroups,formFields} = defProps;
  
  if(tagName==='scm:if' || tagName==='scm:elseif'){
    if(attributes.condition===undefined){return false;}
    const condition = attributes.condition;
    const paramsPattern = /[^${\}]+(?=})/g;
    // console.log('condition',condition);
    let extractParams = condition.match(paramsPattern);
    let formulaExpExe = condition;
    let formulaValue = {
      selectedValue:''
    }
    // console.log('isSet(extractParams,[])',isSet(extractParams,[]));
    isSet(extractParams,[]).map((expFiedName)=>{
      const exactFieldName = expFiedName;//.replace(windowName+'.','');
      // console.log('dynamicVar11',dynamicVar,expFiedName);
      const dynamicVal = extractFieldValue(dynamicVar,expFiedName);
      if(isSet(dynamicVal,null)!==null){
        let finalVal = dynamicVal;
        if (typeof dynamicVal === 'object' && !Array.isArray(dynamicVal) && dynamicVal !== null) {
          if (dynamicVal.selected_value !== undefined) {
            finalVal = dynamicVal.selected_value;
          } else if (dynamicVal.value !== undefined) {
            finalVal = dynamicVal.value;
          }
        }
        formulaValue = {
              selectedValue:isSet(finalVal,null)
            }
      }else if(exactFieldName==='scm_loggedin_user_role'){
        try{
          const userInfo = getUserInfo();
          const userInfoData = userInfo.data;
          const selectedValue = userInfoData.role_name;
          // console.log(" ",userInfoData);
          formulaValue = {
            selectedValue:selectedValue
          }
        }catch(e){
          console.log('e',e);
        }
      }else if(exactFieldName==='scm_loggedin_user_profile'){
          const userInfo = getUserInfo();
          try{
            const userInfoData = userInfo.data;
            const selectedValue = userInfoData.profile_name;
            formulaValue = {
              selectedValue:selectedValue
            }
          }catch(e){
    
          }
      }else{
        
        const valueGrp = getSelectedValueFromForm({fieldGroups:fieldGroups,subformData:[],mappingTags:[]},{searchBy:'name',fieldData:{},fieldName:exactFieldName},false);
        formulaValue={
          ...valueGrp,
          selectedDisplayValue:getSelectedValueBasedOnField(isSet(valueGrp.field,{}),'',true)
        }
        const indexing = isSet(formFields,[]).findIndex((i=>i.label.toLowerCase()===exactFieldName.toLowerCase()));
        // console.log('indexingindexing',indexing,formFields);
        if(indexing!==-1){
          formulaValue={
            ...valueGrp,
            selectedDisplayValue:isSet(formFields,[])[indexing].value
          }
        }
      }
      
      try{
        formulaExpExe = formulaExpExe.replace('${'+isSet(expFiedName,null)+'}',"'"+isSet(formulaValue.selectedDisplayValue,isSet(formulaValue.selectedValue,null))+"'");
        // console.log('dynamicVar11 formulaExpExe1',condition,'${'+isSet(expFiedName,null)+'}',"'"+isSet(formulaValue.selectedDisplayValue,isSet(formulaValue.selectedValue,null))+"'",eval(formulaExpExe),formulaExpExe);
        if(eval(formulaExpExe)===true){
          returnDecision={
            ...returnDecision,
            elseif:{
              result:true,
              children:children,
              attributes:attributes
            }
          }
        }
      }catch(e){

      }
     
    })
  }else if(tagName==='scm:else'){
    // console.log('formulaValue',attributes,children);
    returnDecision={
      ...returnDecision,
      else:{
        result:true,
        children:children,
        attributes:attributes
      }
    }
  }
  return returnDecision;
}